import axios, { AxiosError, AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
const onResponse = (response: AxiosResponse): AxiosResponse => {
  // console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  // console.error(`[response error] [${JSON.stringify(error)}]`);
  if (error.response?.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.error('Session expired. Please login again.');
    setTimeout(() => {
      window.location.replace('/login');
    }, 1000);
  }
  return Promise.reject(error);
};
export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
});

apiClient.interceptors.response.use(onResponse, onResponseError);
